// What a settled figure cell shows when the row carries no number for it. A zero IS a number and
// reads as one; this stands for the absence of one, so the column still lines up and an empty cell
// is not read as a zero that happened to render blank.
export const NO_DATA = '—'

// A cell that has not got its numbers yet says so through `loading` and draws nothing at all; this
// answers only for a cell that has settled without one. An empty string counts as absent -- the
// table builders use it as their own "nothing to report" value.
export const hasCellData = (value: unknown): boolean => {
  if (null == value || '' === value) return false

  return 'number' != typeof value || Number.isFinite(value)
}
